import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import router from '../router';
import store from '../store/index';
import types from '../store/types';
import { removeToken } from '@/utils/auth';

let axiosPromiseArr = [];

const baseApi = axios.create({
  baseURL: '/api/xfmf',
  headers: {
    'Content-Type': 'application/json'
  },
});

const singleErrorMessage = error => {
  if (document.getElementsByClassName('el-message--error').length === 0) {
    Message.error(error);
  }
};

baseApi.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken(cancel => {
      axiosPromiseArr.push({ cancel });
    });
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }
    return config;
  },
  error => {
    return Promise.reject(new Error(error));
  }
 );

// eslint-disable-next-line
baseApi.interceptors.response.use(undefined, error => {
  if (error.message.indexOf('timeout') >= 0) {
    return Promise.reject(new Error('请求超时，请检查网络连接'));
  }
  const { data, status, config } = error.response || {};
  if (status === 404) {
    singleErrorMessage('未找到接口');
    return Promise.reject(new Error());
  }
  if (status === 403) {
    // singleErrorMessage(data.message);
    store.commit(types.CLEAR_LOGININFO);
    removeToken();
    router.push('/login');
    return Promise.reject(new Error());
  }
  if ((config || {}).responseType === 'blob') {
    const fileReader = new FileReader();
    fileReader.onload = e => {
      const { message, code } = JSON.parse(fileReader.result);
      singleErrorMessage(`${message}(${code})`);
      return Promise.reject(new Error(`${message}(${code})`));
    };
    fileReader.readAsText(data);
  } else {
    const errorMsg = `${data.message}(${data.code})`;
    singleErrorMessage(errorMsg);
    return Promise.reject(errorMsg);
  }
});

export default baseApi;



// WEBPACK FOOTER //
// ./src/api/base.js